<template>
  <v-list-item class="py-3">
    <v-list-item-content class="px-3">
      <v-list-item-title>{{ $t('texts.language.'+[item.language]) }}</v-list-item-title>
      <v-list-item-subtitle>{{ $t('texts.proficiency.'+[item.proficiency]) }}</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action
      :class="!$vuetify.breakpoint.xsOnly ? 'pr-3' : ''"
      :style="!$vuetify.breakpoint.xsOnly ? 'flex-direction: row; align-items: center; width: 80px' : ''"
    >
      <v-tooltip color="info" left>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon
            :to="{ name: 'employee.resume.language', params: { id: item.id, item } }"
          >
            <v-icon color="primary">mode_edit</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('texts.edit') }}</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  name: 'EmployeeResumeLanguageItem',
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
